import { Link } from "react-router-dom";
import { List, ListInlineItem } from "reactstrap";
import { USER_SOCIAL_DATA } from "../../../../Data/Users";

const UserSocialMedia = () => {
  return (
    <div className="social-media">
      <List type="inline" className="align-items-center">
        {USER_SOCIAL_DATA.map(({ link, icon }, index) => (
          <ListInlineItem key={index}>
            <Link to={link} target="_blank">
              <i className={`fa fa-${icon}`}></i>
            </Link>
          </ListInlineItem>
        ))}
      </List>
    </div>
  );
};

export default UserSocialMedia;
